module.exports = __webpack_public_path__ + "images/category_lp/car/store_images/5@2x_ff41e76dde59a40d9c7209700ada2aef.png";